export default ({ bins, dt, defaultTz }) => {
    // bins :: How many windows there should be in one calendar day
    // dt :: Candidate moment datetime that is going to be labelled with its bin
    // datetime2binLabel returns a string "bin label": the name of a category for
    // a datum. Lower `bins`, fewer categories. More bins, more categories.
    // Bins must be a multiple of 24, and <= 24 (i.e. 24 % bins == 0)
    // Return value is moment time to bin hour (if bins is valid),
    // else the input moment time
    // All grouping is done with respect to input dt's timezone, or the defaultTz
    // if undefined
    if (bins == null || 24 % bins > 0) {
        throw new Error(`Invalid bins number ${bins}`);
    }
    if (dt.tz() == null && defaultTz) dt.tz(defaultTz);
    const hoursPerBin = 24 / bins;

    for (let hourStart = 0; hourStart < 24; hourStart += hoursPerBin) {
        if (dt.hours() >= hourStart && dt.hours() < hourStart + hoursPerBin) {
            return dt.clone().set({ hour: hourStart, minute: 0, second: 0, millisecond: 0 });
        }
    }
    // Should not be possible
    throw new Error('Input datetime could not be binned');
};
